import { MutableRefObject } from 'react';
import * as PIXI from "pixi.js"

import * as FBRConstants from '../FBRConstants';
import * as FBRTypes from '../FBRTypes';

const createInstructionsScreen = (
	backgroundTexture: PIXI.Texture,
	exitButtonTexture: PIXI.Texture,
	//pixiAppRef: MutableRefObject<PIXI.Application | undefined>,
	//globalState: MutableRefObject<FBRTypes.GlobalState>,
) => {
	const screenContainer = new PIXI.Container();

	screenContainer.visible = false;

	const backgroundSprite = PIXI.Sprite.from(backgroundTexture);
	backgroundSprite.x = 0;
	backgroundSprite.y = 0; 
	
	const exitButtonSprite = PIXI.Sprite.from(exitButtonTexture);
	exitButtonSprite.interactive = true;
	exitButtonSprite.anchor.set(0.5, 0.5);
	exitButtonSprite.x = FBRConstants.STAGE_WIDTH/2;
	exitButtonSprite.y = FBRConstants.STAGE_HEIGHT - 150;

	exitButtonSprite.on('pointerover', () => {
		exitButtonSprite.scale.set(1.07, 1.07);
	});
	
	exitButtonSprite.on('pointerdown', () => {
		exitButtonSprite.tint = 0x4242aa;
	});
	
	exitButtonSprite.on('pointerout', () => {
		exitButtonSprite.scale.set(1, 1);
		exitButtonSprite.tint = 0xFFFFFF;
	});

	exitButtonSprite.on('pointerdown', () => {
		screenContainer.visible = false;
	});

	screenContainer.addChild(backgroundSprite);	
	screenContainer.addChild(exitButtonSprite);	

	const _update = () => {
	}

	const _setVisibility = (visibility: boolean) => {
		screenContainer.visible = visibility;
	}
	
	return {
		container: screenContainer,
		update: _update,
		setVisibility: _setVisibility,
	};
};

export default createInstructionsScreen;
